import { render, staticRenderFns } from "./FaPiao.vue?vue&type=template&id=2e441cce&scoped=true&"
import script from "./FaPiao.vue?vue&type=script&lang=js&"
export * from "./FaPiao.vue?vue&type=script&lang=js&"
import style0 from "./FaPiao.vue?vue&type=style&index=0&id=2e441cce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e441cce",
  null
  
)

export default component.exports